export default __webpack_public_path__ + "static/media/100_1494.c1eeeb66.jpg";